export function formatRegimen(regimen) {
    
    if(regimen == "612") {
        return "Persona física con actividad empresarial y profesional";
    }

    return regimen;
}

export function formatFormaPago(regimen) {
    
    if(regimen == "01") {
        return "Efectivo";
    }

    return regimen;
}

export function formatMetodoPago(regimen) {
    
    if(regimen == "PUE") {
        return "Pago en una sola exhibición";
    }
    
    if(regimen == "PPD") {
        return "Pago en parcialidades o diferido";
    }

    return regimen;
}